exports = module.exports = require("../../../../../../var/www/html/cartaz-pratico/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-enter-active[data-v-7fee0ebf],.fade-leave-active[data-v-7fee0ebf]{transition:all .4s}.fade-enter[data-v-7fee0ebf],.fade-leave-to[data-v-7fee0ebf]{opacity:0}.modal[data-v-7fee0ebf]{background-color:rgba(0,0,0,.75)}", ""]);

// exports
